const SERVICE_NAMES = {
	POSTHOG: "postHog",
	MOENGAGE: "moEngage",
};

export default SERVICE_NAMES;
